import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  width: 800px;
  max-width: 94vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  color: #222;
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

export const Header = styled.div`
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(p) => p.color || '#2d2d2d'};
  font-weight: 600;
  font-size: 16px;

  /* força todo o conteúdo a ser branco */
  * {
    color: #fff !important;
    fill: #fff !important; /* cobre ícones SVG */
  }
`;

export const Body = styled.div`
  padding: 20px;
  display: block;
  overflow-y: auto;
`;

export const Footer = styled.div`
  padding: 16px 20px 20px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
`;

export const Col = styled.div`
  grid-column: span ${(p) => p.span || 12};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
`;

export const TextInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  &:disabled {
    background: #f7f7f7;
    color: #9a9a9a;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }
`;

export const ScrollBox = styled.div`
  border: 1px solid #eee;
  border-radius: 10px;
  max-height: 350px;
  overflow: auto;
  background: #fafafa;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const RoleBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: ${(p) =>
    p.$role === 'CREATOR'
      ? '#fff3cd'
      : p.$role === 'ADMIN'
      ? '#d1ecf1'
      : '#e2e3e5'};
  color: ${(p) =>
    p.$role === 'CREATOR'
      ? '#856404'
      : p.$role === 'ADMIN'
      ? '#0c5460'
      : '#383d41'};
  border: 1px solid
    ${(p) =>
      p.$role === 'CREATOR'
        ? '#ffeaa7'
        : p.$role === 'ADMIN'
        ? '#bee5eb'
        : '#d6d8db'};
`;

export const Button = styled.button`
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  background: ${(p) => p.bg || '#007bff'};
  color: ${(p) => p.color || '#fff'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover:not(:disabled) {
    background: ${(p) => p.bg || '#0056b3'};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const DangerButton = styled(Button)`
  background: #dc3545;
  color: #fff;

  &:hover:not(:disabled) {
    background: #c82333;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
`;

export const GhostButton = styled.button`
  background: transparent;
  border: 0;
  color: inherit;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

// New styled components for enhanced functionality
export const SearchContainer = styled.div`
  margin-bottom: 16px;
`;

export const MemberRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const MemberInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const MemberActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButton = styled(Button)`
  padding: 6px 12px;
  font-size: 12px;
  background: #6c757d;

  &:hover:not(:disabled) {
    background: #5a6268;
    box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
  }
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f0f0;
    color: #333;
  }
`;

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorMessage = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #f5c6cb;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '⚠️';
    font-size: 16px;
  }
`;

export const SuccessMessage = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #c3e6cb;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '✅';
    font-size: 16px;
  }
`;

export const ConfirmationModal = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ListBox = styled.div`
  border: 1px solid #eee;
  border-radius: 10px;
  max-height: 200px;
  overflow: auto;
  background: #fafafa;
  margin-top: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }

  input[type='checkbox'] {
    margin: 0;
    cursor: pointer;
  }

  span {
    flex: 1;
    font-size: 14px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
`;
